<template>
    <div>
        <div style="padding: 20px; display: flex; align-items: center; background-color: white;">
            <van-image round width="60" height="60" :src="user.imageUrl"/>
            <div style="margin-left: 20px; display: flex; flex-direction: column; justify-content: space-around;">
                <div style="color: #4E4E4E; font-size: 18px; font-weight: bold;">{{user.userName || user.loginName}}</div>
                <div style="color: #999999; font-size: 12px; margin-top: 5px;">{{user.userCard ? '已认证' : '未认证'}}</div>
            </div>
        </div>
        <van-cell title="实名认证" :value="user.userCard ? '已认证' : '未认证'" value-class="valueStyle" style="margin-top: 10px;"/>
        <van-cell title="姓名" :value="user.userName" style="margin-top: 10px;" />
        <van-cell title="手机号码" :value="user.userPhone" />
        <van-cell title="我的地址" :value="user.userAddress" />
        <van-cell title="我的邮箱" :value="user.userEmail" />
        <a :href="`tel:${user.userPhone}`" style="text-align: center; background: #1D8FE1; font-size: 12px; color: white; position: fixed; bottom: 20px; left: 10%; right: 10%; width: 80%; padding: 10px 0; border-radius: 25px;">联系Ta</a>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image,Button,Cell} from 'vant';
    Vue.use(Image).use(Button).use(Cell);

    export default {
        name: "Profile",
        data() {
            return {
                id: this.$route.query.id,
                user: {},
            }
        },
        created() {
            this.$axios.get('user/message',{params: {shareUserId: this.id}}).then((res)=>{
                this.user = res.data;
            })
        },
        methods: {
            edit() {
                this.$router.push('/editProfile')
            }
        }
    }
</script>

<style scoped>
    .valueStyle {
        color: red;
    }
</style>
